/* this file is transformed by vux-loader */
/* eslint-disable */
var prefix = '/api'; // 前端开发环境转发接口前缀
console.log('process.env.VUE_APP_BASE');
// prefix : process.env.VUE_APP_BASE === '/gray' ? '/gray'
var baseUrl = process.env.NODE_ENV === 'development' ? prefix : '';
var previewUrl = 'https://preview2.zhongyifu.cn/onlinePreview'; // 预览文件服务地址
var upTarget = baseUrl + '/upload/save'; // 上传接口地址
var AmapServerKey = 'b25650a8ea36faec9ff46cb83b9a98e8'; // 高德地图服务key
var Amapkey = '4a1b93f9d1eb22bb4fa99070ed8f50f8'; // 高德地图key
var baiduServerKey = 'a6b6ecf93b561155535fb94d2d5bacd1'; // 百度服务key
var tokenKey = '[smy-vux] - globalStore/sessionID'; // Session 存储prefix
module.exports = {
  prefix: prefix,
  baseUrl: baseUrl,
  previewUrl: previewUrl,
  AmapServerKey: AmapServerKey,
  upTarget: upTarget,
  Amapkey: Amapkey,
  tokenKey: tokenKey,
  baiduServerKey: baiduServerKey
};